<template>
  <el-dialog :append-to-body="appendToBody" :visible.sync="dialogVisible" width="400px">
    <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px" size="small">
      <el-form-item label="账号：">{{ hideAccount }}</el-form-item>
      <el-form-item prop="code">
        <el-input v-model="editForm.code" type="text" placeholder="请输入验证码" @input="editForm.code = editForm.code.replace(/\D/g, '')">
          <div slot="append">
            <el-button v-if="!isSend" class="active_color ml15" @click="getCode">{{ str }}</el-button>
            <el-button v-if="isSend" class="ml15" disabled>{{ countStr }}</el-button>
          </div>
        </el-input>
      </el-form-item>
      <el-form-item label="旧密码：" prop="old_pass">
        <el-input v-model="editForm.old_pass" type="password" placeholder="请输入旧密码" />
      </el-form-item>
      <el-form-item label="新密码：" prop="new_pass">
        <el-input v-model="editForm.new_pass" type="password" placeholder="请输入新密码" />
      </el-form-item>
      <el-form-item label="确认密码：" prop="checkPass">
        <el-input v-model="editForm.checkPass" type="password" placeholder="请再次输入新密码" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="small" @click="submitForm('editForm')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { sendsmsCode } from '@/api/common'
export default {
  name: 'EditPassWord',
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validatePass1 = (rule, value, callback) => {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入8位及以上字母和数字组合的密码'))
      } else {
        if (this.editForm.checkPass !== '') {
          this.$refs.editForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.editForm.new_pass) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      editForm: {
        code: '', // 验证码
        old_pass: '',
        new_pass: '',
        checkPass: ''
      },
      rules: {
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        old_pass: [{ required: true, message: '请输入旧密码', trigger: 'change' }],
        new_pass: [{ required: true, validator: validatePass1, trigger: 'blur' }],
        checkPass: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      },
      code: '',
      str: '获取验证码',
      countStr: '重新发送（60s）',
      isSend: false
    }
  },
  computed: {
    hideAccount() {
      const account = this.$store.state.user.userPhone
      return account && account.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2')
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
      if (value) {
        this.getPhoneFn()
      }
    },
    dialogVisible(value) {
      !value && this.$emit('update:visible', false)
    }
  },
  methods: {
    ...mapActions('user', ['updatePassFn', 'getPhoneFn']),
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      const { code } = await this.updatePassFn(this.editForm)
      if (code === 200) {
        this.$message.success('修改密码成功')
        this.dialogVisible = false
        await this.$store.dispatch('user/logout')
        this.$router.push(`/login`)
      }
    },
    getCode() {
      sendsmsCode({ account: this.$store.state.user.userPhone }).then(data => {
        if (data) {
          this.code = 1
          this.isSend = true
          let timer = null
          let time = 60
          timer = setInterval(() => {
            if (time === 0) {
              this.str = '重新获取验证码'
              this.countStr = '重新发送（60s）'
              this.isSend = false
              clearInterval(this.timer)
            } else {
              time--
              this.countStr = `重新发送（${time}s）`
            }
          }, 1000)
          this.$once('hook:beforeDestroy', () => {
            clearInterval(timer)
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less"></style>
